import { Close } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import BriaIconButton from "../../BriaIconButton/BriaIconButton";
import styles from "../ApiReferenceDialog.module.scss";

interface ApiReferenceDialogHeaderProps {
	onClose: (e: React.MouseEvent<HTMLButtonElement | SVGElement>) => void;
}

const ApiReferenceDialogHeader = ({ onClose }: ApiReferenceDialogHeaderProps) => {
	return (
		<Box className={styles.header}>
			<Box className={styles.titleSection}>
				<Typography className={styles.title}>API Reference</Typography>
				<Typography className={styles.endpoint}>POST /v2/image/generate</Typography>
			</Box>
			<BriaIconButton onClick={onClose} className={styles.closeButton}>
				<Close />
			</BriaIconButton>
		</Box>
	);
};

export default ApiReferenceDialogHeader;
